import { assign, createMachine } from "xstate"

const initialContext = {
  costoInscripcion: {},
  costoColegiaruta: {},
  loading: false,
}

const cargosMachine = createMachine(
  {
    predictableActionArguments: true,
    context: initialContext,
    id: "cargos",
    initial: "idle",
    states: {
      idle: {
        on: {
          "cargos/COSTO_INSCRIPCION": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "cargos/COSTO_INSCRIPCIONSUCCESS": {
            actions: ["unsetError", "setCostoInscripcion", "unsetLoading"],
            target: "idle",
          },
          "cargos/COSTO_INSCRIPCIONFAIL": {
            actions: ["setError", "unsetCostoInscripcion", "unsetLoading"],
            target: "idle",
          },
          "cargos/COSTO_COLEGIATURA": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "cargos/COSTO_COLEGIATURASUCCESS": {
            actions: ["unsetError", "setCostoColegiatura", "unsetLoading"],
            target: "idle",
          },
          "cargos/COSTO_COLEGIATURAFAIL": {
            actions: ["setError", "unsetCostoColegiatura", "unsetLoading"],
            target: "idle",
          },
        },
      },
    },
  },
  {
    actions: {
      resetMachine: assign(initialContext),
      setCostoInscripcion: assign({
        costoInscripcion: (_, event) => event.payload.data,
      }),
      unsetCostoInscripcion: assign({
        costoInscripcion: {},
      }),
      setCostoColegiatura: assign({
        costoColegiatura: (_, event) => event.payload.data,
      }),
      unsetCostoColegiatura: assign({
        costoColegiatura: {},
      }),
      setNotificacion: assign({
        error: (_, event) => {
          console.log("setNotificacion")
          return ""
        },
      }),
      setError: assign({
        error: (_, event) => {
          console.log(event.payload)
          return event.payload.response?.data?.Mensaje_Error
            ? event.payload.response?.data?.Mensaje_Error
            : event.payload.message
            ? event.payload.message
            : "Ocurrió un error!"
        },
      }),
      unsetError: assign({
        error: null,
      }),
      setLoading: assign({
        loading: true,
      }),
      unsetLoading: assign({
        loading: false,
      }),
    },
  }
)

export default cargosMachine
